import { Injectable } from '@angular/core';
import { OrderDataService } from 'src/app/shared/data-service/order-data.service';
import { map, mergeMap } from 'rxjs/operators';
import { LegacyMatrixService } from 'src/app/shared/services/legacy-matrix.service';

@Injectable({
    providedIn: 'root'
})
export class AnalysesToolTipService {

    constructor(
        private orderDataService: OrderDataService,
        private legacyMatrixService: LegacyMatrixService) {
    }

    getTestToolTipData(accountCode: string, testEurodatKey: string) {
        return this.orderDataService
            .getTestQuotedItems(accountCode, testEurodatKey, true, false)
            .pipe(
                map(t => {
                    const toolTipData = t;
                    toolTipData.parameters = this.orderDataService.getTestParameters([t.testCode], false).pipe(map(p => {
                        toolTipData.parameters = p;
                        return p;
                    }));
                    return toolTipData;
                })
            );
    }

    getPackageToolTipData(accountCode: string, packageEurodatKey: string) {
        return this.orderDataService.getPackageQuotedItems(accountCode, packageEurodatKey, true, false)
            .pipe(map(p => {
                this.sortItemsByOrderNumberThenByCode(p.tests);
                return p;
            }));
    }

    getSubGroupToolTipData(accountCode: string, subGroupCode: string, isCustomerPackage: boolean, isSampleLevelMatrix: boolean) {
        return this.orderDataService.getSubGroupQuotedItems(accountCode, subGroupCode, isCustomerPackage, true, false)
            .pipe(
                mergeMap(async subGroup => {
                    if (!isCustomerPackage && isSampleLevelMatrix) {
                        await this.legacyMatrixService.getQuotableItemProductApplicability(null, true);
                        [subGroup] = this.legacyMatrixService.filterSubGroups([subGroup]);
                    }
                    const toolTipData: any = {};
                    toolTipData.name = subGroup.name;
                    toolTipData.comlimsCode = subGroup.comlimsCode;
                    const res = subGroup.testQuotationLines.concat(subGroup.packageQuotationLines);
                    this.sortItemsBySortIndexThenByCode(res);
                    toolTipData.ciItems = res;
                    return toolTipData;
                })
            );
    }

    getTestCommercialItemToolTipData(testCode: string): Promise<any> {
        return new Promise((resolve) => {
            this.orderDataService.getTestDetails(testCode).subscribe(data => {
                this.orderDataService.getTestParameters([testCode], false).subscribe(parameters => {
                    data.parameters = parameters;
                    resolve(data);
                });
            });
        });
    }

    getPackageCommercialItemToolTipData(packageCode: string): Promise<any> {
        return new Promise((resolve) => {
            this.orderDataService.getPackageDetails(packageCode, false).subscribe(data => {
                this.sortItemsByOrderNumberThenByCode(data.tests);
                resolve(data);
            });
        });
    }

    getTestBundleCommercialItemToolTipData(testBundleCode: string): Promise<any> {
        return new Promise((resolve) => {
            this.orderDataService.getTestBundleDetails(testBundleCode, false).subscribe(data => {
                this.sortItemsByOrderNumberThenByCode(data.tests);
                resolve(data);
            });
        });
    }

    private sortItemsByOrderNumberThenByCode(inputArray: []) {
        inputArray.sort((a: any, b: any) => {
            if (a.orderNumber === b.orderNumber) {
                return a.code > b.code ? 1 : -1;
            } else {
                return a.orderNumber - b.orderNumber;
            }
        });
    }

    private sortItemsBySortIndexThenByCode(inputArray: []) {
        inputArray.sort((a: any, b: any) => {
            if (a.sortIndex === b.sortIndex) {
                return a.code > b.code ? 1 : -1;
            } else {
                return a.sortIndex - b.sortIndex;
            }
        });
    }
}
